//# sourceMappingURL=navbar.mjs.map
/// <reference types="./navbar.d.mts" />
import * as $when from "../../altar/altar/when.mjs";
import * as $auth0 from "../../auth0_client/auth0/client.mjs";
import * as $remote from "../../data_types/data/remote.mjs";
import * as $combobox from "../../ds/ds/components/combobox.mjs";
import * as $l from "../../ds/ds/components/layout.mjs";
import * as $pp from "../../ds/ds/components/profile_picture.mjs";
import * as $skeleton from "../../ds/ds/components/skeleton.mjs";
import * as $i from "../../ds/ds/icons.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $uri from "../../gleam_stdlib/gleam/uri.mjs";
import * as $redraw from "../../redraw/redraw.mjs";
import * as $compose from "../../redraw_batteries/redraw/batteries/compose.mjs";
import * as $a from "../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../redraw_dom/redraw/dom/html.mjs";
import * as $effect from "../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $result_ from "../../tiamat/gleam/result_.mjs";
import * as $msg from "../data/msg.mjs";
import * as $route from "../data/route.mjs";
import * as $store from "../data/store.mjs";
import { toList, Empty as $Empty, CustomType as $CustomType } from "../gleam.mjs";
import * as $common from "../view/common.mjs";
import * as $s from "../view/navbar_styles.mjs";

class NavLink extends $CustomType {
  constructor(icon, title, link) {
    super();
    this.icon = icon;
    this.title = title;
    this.link = link;
  }
}

class Section extends $CustomType {
  constructor(title) {
    super();
    this.title = title;
  }
}

function navlink(icon, title, link) {
  return new NavLink(
    icon,
    title,
    $list.map(link, (link) => { return $route.to_uri(link); }),
  );
}

function navlinks() {
  return toList([
    new Section("Administration"),
    navlink(
      $i.maintenance,
      "Maintenance",
      toList([new $route.Administration(new $route.Maintenance())]),
    ),
    navlink(
      $i.translate,
      "Choice translations",
      toList([new $route.Administration(new $route.ChoiceTranslations(0))]),
    ),
    navlink(
      $i.translate,
      "Section translations",
      toList([new $route.Administration(new $route.SectionTranslations(0))]),
    ),
    navlink(
      $i.sparkles,
      "Model assignments",
      toList([new $route.Administration(new $route.ModelAssignments())]),
    ),
    navlink(
      $i.gear,
      "Jobs",
      toList([new $route.Administration(new $route.Jobs())]),
    ),
    navlink(
      $i.globe,
      "Websites",
      toList([new $route.Administration(new $route.Websites())]),
    ),
    new Section("Organization"),
    navlink(
      $i.user,
      "Authentication",
      toList([
        new $route.Organization(
          new $route.Authentication(new $route.ListUsers()),
        ),
        new $route.Organization(
          new $route.Authentication(new $route.InviteUsers()),
        ),
      ]),
    ),
    navlink(
      $i.gear,
      "Setup",
      toList([
        new $route.Organization(new $route.Setup(new $route.Config())),
        new $route.Organization(new $route.Setup(new $route.Prompts())),
        new $route.Organization(new $route.Setup(new $route.Init())),
      ]),
    ),
    navlink(
      $i.info,
      "Automations",
      toList([new $route.Organization(new $route.Automations())]),
    ),
    navlink(
      $i.lightbulb_flash,
      "Feature flags",
      toList([new $route.Organization(new $route.FeatureFlags())]),
    ),
    navlink(
      $i.bell,
      "Status",
      toList([new $route.Organization(new $route.Status())]),
    ),
    navlink(
      $i.gear,
      "Weaviate Admin",
      toList([new $route.Organization(new $route.Weaviate())]),
    ),
    navlink(
      $i.lightbulb_flash,
      "Search weaviate",
      toList([new $route.Organization(new $route.AiSearch())]),
    ),
    new Section("Content Library"),
    navlink(
      $i.book,
      "Ingestion Control",
      toList([
        new $route.ContentLibrary(
          new $route.IngestionControl(new $route.Controls()),
        ),
        new $route.ContentLibrary(
          new $route.IngestionControl(new $route.Control("_")),
        ),
      ]),
    ),
    navlink(
      $i.document,
      "Data Sources",
      toList([new $route.ContentLibrary(new $route.DataSources(0))]),
    ),
    new Section("Project"),
    navlink(
      $i.file,
      "Files",
      toList([new $route.Project(new $route.ListProjectFile())]),
    ),
    new Section("Proposal"),
    navlink(
      $i.archive,
      "Versioning",
      toList([new $route.Proposal(new $route.VersioningList())]),
    ),
  ]);
}

function nav_href(links, org_id) {
  let link = $list.first(links);
  return $result_.map_unwrap(
    link,
    "#",
    (link) => {
      let _pipe = link;
      let _pipe$1 = $route.with_org(_pipe, org_id);
      return $uri.to_string(_pipe$1);
    },
  );
}

function are_same_paths(loop$link, loop$route) {
  while (true) {
    let link = loop$link;
    let route = loop$route;
    if (link instanceof $Empty) {
      if (route instanceof $Empty) {
        return true;
      } else {
        return false;
      }
    } else if (route instanceof $Empty) {
      return false;
    } else {
      let fst = link.head;
      if (fst === "_") {
        let rest1 = link.tail;
        let rest2 = route.tail;
        loop$link = rest1;
        loop$route = rest2;
      } else {
        let fst = link.head;
        let snd = route.head;
        if (fst === snd) {
          let rest1 = link.tail;
          let rest2 = route.tail;
          loop$link = rest1;
          loop$route = rest2;
        } else {
          return false;
        }
      }
    }
  }
}

function are_same_uri(link, route) {
  return $bool.guard(
    link.path === route.path,
    true,
    () => {
      let lpath = $string.split(link.path, "/");
      let rpath = $string.split(route.path, "/");
      return are_same_paths(lpath, rpath);
    },
  );
}

function section(title) {
  return $s.nav_section(
    toList([]),
    toList([
      $s.nav_section_title(toList([]), toList([$h.text(title)])),
      $common.separator(),
    ]),
  );
}

function render_navlinks(store, navlinks) {
  let route = $route.to_uri(store.route);
  return $s.nav_links(
    toList([]),
    $list.map(
      navlinks,
      (item) => {
        if (item instanceof NavLink) {
          let active = $list.find(
            item.link,
            (_capture) => { return are_same_uri(_capture, route); },
          );
          let active$1 = $result.is_ok(active);
          return $s.nav_link(
            active$1,
            toList([$a.href(nav_href(item.link, store.organization))]),
            toList([$i.small(item.icon()), $h.text(item.title)]),
          );
        } else {
          let title = item.title;
          return section(title);
        }
      },
    ),
  );
}

function user_section(store, logout) {
  return $when.some_(
    store.user,
    () => { return $skeleton.full_width(38); },
    (user) => {
      return $s.user_section(
        toList([]),
        toList([
          $l.row(
            toList([$l.align("center"), $l.gap(12)]),
            toList([]),
            toList([
              $pp.from_user(user.picture, "", new $pp.Medium()),
              $l.column(
                toList([]),
                toList([]),
                toList([
                  $s.user_name(
                    toList([]),
                    toList([$h.text($option.unwrap(user.name, ""))]),
                  ),
                  $s.user_email(
                    toList([]),
                    toList([$h.text($option.unwrap(user.email, ""))]),
                  ),
                ]),
              ),
            ]),
          ),
          $s.user_logout(
            toList([$e.on_click(logout)]),
            toList([$i.tiny($i.logout())]),
          ),
        ]),
      );
    },
  );
}

function state_changed(user) {
  return $effect.from(
    (dispatch, _) => {
      let _pipe = user;
      let _pipe$1 = new $msg.AuthStateChanged(_pipe);
      dispatch(_pipe$1);
      return undefined;
    },
  );
}

function use_logout(store) {
  let dispatch = $store.use_effect_dispatch();
  return ((_capture) => { return $redraw.use_callback(_capture, []); })(
    (_) => {
      dispatch($auth0.logout(store.client, state_changed));
      return undefined;
    },
  );
}

function organization_selector() {
  return $compose.children(
    $combobox.combobox(),
    (combobox) => {
      return $redraw.component_(
        "OrganizationSelector",
        (_) => {
          let store = $store.use_state();
          let dispatch = $store.use_dispatch();
          let $ = store.organizations;
          if ($ instanceof $remote.NotLoaded) {
            return $skeleton.skeleton(100, 30);
          } else if ($ instanceof $remote.Loading) {
            return $skeleton.skeleton(100, 30);
          } else if ($ instanceof $remote.Errored) {
            let error = $[0];
            return $h.text("Error: " + error);
          } else {
            let organizations = $[0][1];
            let selected = store.organization;
            let on_selected = (org) => {
              dispatch(new $msg.UserSelectedOrganization(org));
              return undefined;
            };
            return $l.column(
              toList([$l.gap(3)]),
              toList([]),
              toList([
                $s.selected_organization(
                  toList([]),
                  toList([$h.text("Selected organization")]),
                ),
                (() => {
                  let _pipe = $combobox.on_selected_(on_selected);
                  let _pipe$1 = $combobox.selected(_pipe, selected);
                  let _pipe$2 = $combobox.placeholder(
                    _pipe$1,
                    "Select organization",
                  );
                  return combobox(
                    _pipe$2,
                    $list.map(
                      organizations,
                      (organization) => {
                        return $combobox.choice(
                          organization.display_name,
                          organization.id,
                        );
                      },
                    ),
                  );
                })(),
              ]),
            );
          }
        },
      );
    },
  );
}

export function navbar() {
  return $redraw.compose(
    organization_selector(),
    (organization_selector) => {
      return $redraw.component_(
        "Navbar",
        (_) => {
          let store = $store.use_state();
          let navlinks$1 = $redraw.use_memo(navlinks, []);
          let logout = use_logout(store);
          return $s.navbar(
            toList([]),
            toList([
              $s.navbar_main(
                toList([]),
                toList([
                  user_section(store, logout),
                  organization_selector(undefined),
                  render_navlinks(store, navlinks$1),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}
